import cn from 'classnames';
import React, {FC} from 'react';

import {IMenuStructureItem} from 'store/slices/menu-slice/menu-slice-types';

import {NewSideMenuListItem} from './new-side-menu-list-item';

interface INewSideMenuListProps {
    items?: IMenuStructureItem[];
    depth: number;
    path?: string;
    className?: cn.Argument;
}

export const NewSideMenuList: FC<INewSideMenuListProps> = (
    {
        items, path = '', depth, className,
    }: INewSideMenuListProps,
) => (
    <div className={cn('new-side-menu__list', className)}>
        {items?.map(item => (
            <NewSideMenuListItem
                key={item.id}
                item={item}
                path={path}
                depth={depth}
            />
        ))}
    </div>
);
